import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import LinkButton from "./LinkButton";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { toast } from "react-hot-toast";
import FloatingLabel from "react-bootstrap/esm/FloatingLabel";
import { Button } from "react-bootstrap";
import rngIcon from "../media/images/surprise-box.svg"

function GameStart(props) {
  const [show, setShow] = useState(true);
  const [gameID, setGameID] = useState();
  const game_list = useRef(null)

  const handleClose = () => {
    setShow(false);
    props.onGameStartModal(false);
  };
  useEffect(() => {
    if (props.play) {
      const intervalId = setInterval(() => {
        if (props.play) {
          props.setTime((prevSeconds) => prevSeconds + 1);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [props.play]);

  const restartGame = () => {
    props.setResetGame(1);
    props.setTime(0);
    props.onGameStartModal(false);
    handleClose()
  };

  const startGame = () => {
    if(game_list.current === null){
      handleClose()
    }else{
    console.log(gameID)
      if(gameID === undefined){
        setGameID(game_list.current[1].value)
        props.setSelectedGame(game_list.current[1].value);
      }
      handleClose()
    }
  }

  const randomGameSelect = () => {
    let rnd = Math.floor(Math.random() * game_list.current.length) + 1
    let rnd_game_id = game_list.current[rnd].value
    setGameID(rnd_game_id);
    props.setSelectedGame(rnd_game_id);
    handleClose()
  }

  const handleGameID = (e) => {
    setGameID(e.target.value);
    props.setSelectedGame(e.target.value);
    handleClose()
  };
  useEffect(() => {
    if (props.openGameStartModal) {
      setShow(props.openGameStartModal);
    }
  }, [props.openGameStartModal]);

  return (
    <>
      {props.timesPlayed > 0 ? (
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title>
              <b>Well Done!</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>You've completed {props.gameTitle}!</h2>
            <h5>
              You can reset the game play again by pressing the button below.
              <br />
              <br />
              {props.timer ? "Your time: " + props.time : ""}
            </h5>
            <br />
            <Row>
              <Col>
              <LinkButton function={restartGame} title="Restart" />
              </Col>
              <Col></Col>
              <Col style={{ textAlign: "right" }}>
                <LinkButton url="/home" title="Home" />
              </Col>
              <Col style={{ textAlign: "right" }}>
              <Button size="lg" variant='danger' onClick={() => handleClose()} >Close</Button>
              </Col>
              
            </Row>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title>
              <h1>
                <b>Welcome to {props.gameTitle}!</b>
              </h1>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br /> <h3>{props.gameDescription}</h3>
            <br />
            {props.gameSelect && (
              <FloatingLabel label="Select a Game" controlId="gameSelect">
                <Form.Select onChange={(e) => handleGameID(e)} ref={game_list}>
                  <option selected disabled>--Select Game--</option>
                  {props.gameSelect.map((game) => {
                    return (
                      <option key={game.id} value={game.id}>
                        {game.name}
                      </option>
                    );
                  })}
                </Form.Select>
              </FloatingLabel>
            )}
            <br />
            <Row>
              
              {!props.gameSelect && <Col style={{ textAlign: "center" }}><LinkButton title="Start Game" function={() => startGame()} /></Col>}
              {props.gameSelect && <Col style={{ textAlign: "center" }}><LinkButton title="Random Game  " icon={<img src={rngIcon} height={30} width={30}/>} function={() => randomGameSelect()} /></Col>}
              <Col style={{ textAlign: "center" }}>
                <LinkButton url="/home" title="Home" />
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
export default GameStart;
